import { NavigationBar } from 'app/views/components/navigation-bar';
import { RightDrawer } from 'app/views/components/right-drawer';
import { Outlet } from 'react-router';
import { AppWrapper, ContentWrapper, MainContent } from './Layout.styles';
import { ChangeFacilityDialog } from './components/change-facility-dialog';
import { ProjectBanner } from './components/project-banner/ProjectBanner';
import { useRememberRoute } from './useRememberRoute';
import { MobileNavigationBar } from './components/mobile-navigation-bar';
import { useMobileNavRef } from './useMobileNavPortal';
import { MobileSubnavigationBar } from './components/mobile-subnavigation-bar';
import { EventsDrawer } from 'app/views/alerts/components/events-drawer';
import { TriggerError } from 'app/components/trigger-error/TriggerError';

export const LayoutWrapper = () => {
  const { mobileNav, mobileSubnav } = useMobileNavRef();

  useRememberRoute();

  return (
    <AppWrapper>
      <ChangeFacilityDialog />
      <TriggerError />
      <MobileNavigationBar ref={mobileNav} />
      <MobileSubnavigationBar ref={mobileSubnav} />
      <NavigationBar />
      <MainContent>
        <ProjectBanner />
        <ContentWrapper>
          <Outlet context={{ mobileNav: mobileNav.current, mobileSubnav: mobileSubnav.current }} />
          <EventsDrawer />
        </ContentWrapper>
      </MainContent>
      <RightDrawer />
    </AppWrapper>
  );
};
